import axios from 'axios';
import qs from 'qs';

const API_Url = 'http://w-s/';

export default {
	actions: {
		AllThemesAct({commit}) {
			axios.get(API_Url + 'docs/theme.get')
			.then((response) => {
				const ThemeRes = response.data.response;
				commit('AllThemesMut', ThemeRes)
			})
			.catch(error => {
				const Error = error.message;
				commit('ThemeErrorMut', Error)
			});
		},

		ThemeByIDAct({commit}, ThemeID) {
			axios.get(API_Url + 'docs/theme.get?theme_link=' + ThemeID)
			.then((response) => {
				const ThemeRes = response.data.response;
				commit('ThemeByIDMut', ThemeRes)
			})
			.catch(error => {
				const Error = error.message;
				commit('ThemeErrorMut', Error)
			});
		},

		ThemeStatusAct({commit}, [ThemeID, ThemeStatus, AdminId, AdminToken]) {
			let data = {
				'admin_id': AdminId,
				'admin_token': AdminToken,
				'theme_id': ThemeID,
				'theme_status': ThemeStatus,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/theme.status'
			};
			axios(options)
			.then(commit('ThemeSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('ThemeErrorMut', Error);
				}
			});
		},

		ThemeEditAct({commit}, [ThemeID, ThemeTitle, ThemeLink, ThemeDesc, AdminID, AdminToken]) {
			let data = {
				'theme_id': ThemeID,
				'theme_title': ThemeTitle,
				'theme_link': ThemeLink,
				'theme_desc': ThemeDesc,
				'admin_id': AdminID,
				'admin_token': AdminToken,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/theme.edit'
			};
			axios(options)
			.then(commit('ThemeSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('ThemeErrorMut', Error);
				}
			});
		},

		ThemeAddAct({commit}, [ThemeTitle, ThemeLink, ThemeDesc, AdminID, AdminToken]) {
			let data = {
				'theme_title': ThemeTitle,
				'theme_link': ThemeLink,
				'theme_desc': ThemeDesc,
				'admin_id': AdminID,
				'admin_token': AdminToken,
			};
			const options = {
				method: 'POST',
				headers: {'content-type': 'application/x-www-form-urlencoded'},
				data: qs.stringify(data),
				url: API_Url + 'docs/theme.add'
			};
			axios(options)
			.then(commit('ThemeSuccessMut'))
			.catch(error => {
				if (error.response) {
					const Error = error.response.data.error;
					commit('ThemeErrorMut', Error);
				}
			});
		},
	},
	mutations: {
		AllThemesMut(state, ThemeRes) {
			state.AllThemes = ThemeRes;
			state.ThemeErrorMut = [];
		},

		ThemeByIDMut(state, ThemeRes) {
			state.Theme = [];
			state.ThemeErrorMut = [];
			state.Theme = ThemeRes;
		},

		ThemeErrorMut(state, Error) {
			state.ThemeErrorMut = Error;
			state.ThemeSuccess = false;
		},

		ThemeSuccessMut(state) {
			state.ThemeSuccess = true;
			state.ThemeErrorMut = [];
		},
	},
	state: {
		ThemeError: [],
		AllThemes: {},
		Theme: [],
		ThemeSuccess: false,
	},
	getters: {
		AllThemesGet(state) {
			return state.AllThemes;
		},

		ThemeByIDGet(state) {
			return state.Theme;
		},

		ThemeErrorGet(state) {
			return state.ThemeError;
		},

		ThemeSuccessGet(state) {
			return state.ThemeSuccess;
		},
	}
}
